export default __webpack_public_path__ + "e0764a593cb19ae1abb17d88ab55f9f5.png";